import { render, staticRenderFns } from "./StagingProfileWidget.vue?vue&type=template&id=baab9962&scoped=true&"
import script from "./StagingProfileWidget.vue?vue&type=script&lang=js&"
export * from "./StagingProfileWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baab9962",
  null
  
)

export default component.exports